import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import AdminSubHeader from "../../../layouts/partials/AdminSubheader";
import { PROFILES_ACTIONS } from "../../../../redux/profiles/actions";
import {
  selectProfiles,
  profileCreating,
  profilesFilters,
  profilesLoaded,
  profilesMeta,
  selectActiveProfile
} from "../../../../redux/profiles/selectors";
import ProfileForm from "../../../forms/ProfileForm";
import Confirm from "../../../../base/Confirm";
import { dateRender } from "../../../../libs/utils";
import ListView from "../../../../base/ListView";
import { selectProfileGroups } from "../../../../redux/profileGroups/selectors";
import { PROFILE_GROUPS_ACTIONS } from "../../../../redux/profileGroups/actions";

class _Profiles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profiles: this.props.profiles,
      activeProfile: null,
      profilesLoaded: this.props.profilesLoaded
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleUpdate = this._handleUpdate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    profiles: PropTypes.array,
    profilesLoaded: PropTypes.bool,
    loadProfiles: PropTypes.func,
    match: PropTypes.object,
    createProfile: PropTypes.func,
    updateProfile: PropTypes.func,
    deleteProfile: PropTypes.func,
    profileCreating: PropTypes.bool,
    profilesMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    updateProfileGroupsFilters: PropTypes.func,
    loadProfile: PropTypes.func,
    resetActiveProfile: PropTypes.func,
    activeProfile: PropTypes.object,
    profileGroups: PropTypes.array
  };

  UNSAFE_componentWillMount() {
    this.props.loadProfiles();
    this.props.updateProfileGroupsFilters({
      "page[number]": 1,
      "page[size]": 50,
      sort: "name"
    });

    if (this.props.match.params.id) {
      this.props.loadProfile(this.props.match.params.id);
    } else {
      this.props.resetActiveProfile();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.props.loadProfile(nextProps.match.params.id);
    }
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleCreate(values) {
    const data = {
      name: values.name,
      profileGroupId: values.profileGroupId,
      occupations: values.occupations
    };
    this.props.createProfile(data, values.redirect);
  }

  _handleUpdate(values) {
    const data = {
      name: values.name,
      profileGroupId: values.profileGroupId,
      occupations: values.occupations
    };

    this.props.updateProfile(values.id, data);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this profile? This action can not be undone, please make sure no festival is using this profile.",
      {
        title: "Delete Profile",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteProfile(id);
      },
      result => {}
    );
  }

  render() {
    const {
      profiles,
      profilesMeta,
      filters,
      profileCreating,
      activeProfile,
      profileGroups
    } = this.props;

    const listViewConf = {
      dataSet: profiles,
      dataMeta: profilesMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "profileGroup.name",
          value: "Group"
        },
        {
          key: "updatedAt",
          value: "Updated",
          sort: "updated_at",
          render: profile => dateRender(profile.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/profiles"
    };

    return [
      <AdminSubHeader title="Profile" key="subheader" breadcrumbs={[]} />,
      <div className="m-content" key="content">
        <div className="row">
          <div className="col-xl-8">
            <ListView
              config={listViewConf}
              handleDelete={this._handleDelete}
              handleFilterUpdate={this._handleFilterUpdate}
            />
          </div>
          <div className="col-xl-4">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title">
                    <span className="m-portlet__head-icon">
                      <i className="flaticon-map-location" />
                    </span>
                    <h3 className="m-portlet__head-text">
                      {activeProfile ? "Edit Profile" : "Create Profile"}
                    </h3>
                  </div>
                </div>
              </div>
              <ProfileForm
                onSubmit={
                  activeProfile ? this._handleUpdate : this._handleCreate
                }
                isCreating={profileCreating}
                profile={activeProfile}
                groups={profileGroups}
              />
            </div>
          </div>
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadProfiles: params => dispatch(PROFILES_ACTIONS.loadAllRequest(params)),
  loadProfile: id => dispatch(PROFILES_ACTIONS.loadRequest(id)),
  resetActiveProfile: () => dispatch(PROFILES_ACTIONS.resetActive()),
  updateProfileGroupsFilters: filters =>
    dispatch(PROFILE_GROUPS_ACTIONS.updateFilters(filters)),
  createProfile: (values, redirect) =>
    dispatch(PROFILES_ACTIONS.createRequest(values, redirect)),
  updateProfile: (id, values) =>
    dispatch(PROFILES_ACTIONS.updateRequest(id, values)),
  deleteProfile: id => dispatch(PROFILES_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(PROFILES_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    profiles: selectProfiles(state),
    profilesLoaded: profilesLoaded(state),
    profileCreating: profileCreating(state),
    profilesMeta: profilesMeta(state),
    profileGroups: selectProfileGroups(state),
    activeProfile: selectActiveProfile(state),
    filters: profilesFilters(state)
  };
};

const Profiles = connect(mapStateToProps, mapDispatchToProps)(_Profiles);

export default Profiles;
